import React from 'react';
import styled from 'styled-components';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import { TRANSITION } from 'theme';
import { FirstChild } from 'utils/transitions';

const StyledTabContent = styled.div`
    &.fade {
        /* Active must come after its previous state */
        &-enter {
            opacity: 0;
        }

        &-enter-active {
            opacity: 1;
        }

        &-leave {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            opacity: 1;
        }

        &-leave-active {
            opacity: 0;
        }

        /* Need the transition on the active classes to animate with react-select */
        &-enter-active,
        &-leave-active {
            transition: opacity ${TRANSITION.LENGTH_LONG} ${TRANSITION.BEZIER};
        }
    }
`;

const TabContent = ({ isOpen, children, props }) => {
    return (
        <CSSTransitionGroup
            component={FirstChild}
            transitionName="fade"
            transitionEnterTimeout={parseInt(TRANSITION.LENGTH_LONG, 10)}
            transitionLeaveTimeout={parseInt(TRANSITION.LENGTH_LONG, 10)}
        >
            {isOpen && <StyledTabContent {...props}>{children}</StyledTabContent>}
        </CSSTransitionGroup>
    );
};

export default TabContent;
